import Cookies, { CookieAttributes } from 'js-cookie'

const defaultOptions = {
  domain: window.location.hostname === 'localhost' ? window.location.hostname : `.${window.location.hostname}`,
  path: '/',
  secure: window.location.hostname !== 'localhost',
}

export const getCookie = Cookies.get

export const setCookie = (name: string, value: string | object, options?: CookieAttributes) => {
  return Cookies.set(name, value, {
    ...defaultOptions,
    ...options,
  })
}

export const removeCookie = (name: string, options?: CookieAttributes) => {
  return Cookies.remove(name, {
    ...defaultOptions,
    ...options,
  })
}
